import { h as o, nextTick as c } from "vue";
let r = function() {
}, d;
const k = typeof console < "u";
r = (t, e, s = "error") => {
  k && console[s](`[vue-paginate]: ${t} ` + (e ? m(d(e)) : ""));
};
d = (t) => {
  if (t.$root === t)
    return "root instance";
  const e = t._isVue ? t.$options.name || t.$options._componentTag : t.name;
  return (e ? `component <${e}>` : "anonymous component") + (t._isVue && t.$options.__file ? ` at ${t.$options.__file}` : "");
};
const m = (t) => (t === "anonymous component" && (t += ' - use the "name" option for better debugging messages.'), `
(found in ${t})`), g = {
  name: "refapp-paginate",
  props: {
    name: {
      type: String,
      required: !0
    },
    list: {
      type: Array,
      required: !0
    },
    per: {
      type: Number,
      default: 3,
      validator(t) {
        return t > 0;
      }
    },
    tag: {
      type: String,
      default: "ul"
    },
    container: {
      type: Object,
      default: null
    }
  },
  computed: {
    parent() {
      return this.container ? this.container : this.$parent;
    },
    currentPage: {
      get() {
        if (this.parent.paginate[this.name])
          return this.parent.paginate[this.name].page;
      },
      set(t) {
        this.parent.paginate[this.name].page = t;
      }
    },
    pageItemsCount() {
      const t = this.list.length, e = this.currentPage * this.per + 1, s = Math.min(this.currentPage * this.per + this.per, t);
      return `${e}-${s} of ${t}`;
    },
    lastPage() {
      return Math.ceil(this.list.length / this.per);
    }
  },
  mounted() {
    if (this.per <= 0 && r(`<paginate name="${this.name}"> 'per' prop can't be 0 or less.`, this.parent), !this.parent.paginate[this.name]) {
      r(`'${this.name}' is not registered in 'paginate' array.`, this.parent);
      return;
    }
    this.paginateList();
  },
  watch: {
    currentPage() {
      this.paginateList();
    },
    list() {
      this.currentPage >= this.lastPage && (this.currentPage = (this.lastPage || 1) - 1), this.paginateList();
    },
    per() {
      this.currentPage = 0, this.paginateList();
    }
  },
  methods: {
    paginateList() {
      const t = this.currentPage * this.per, e = this.list.slice(t, t + this.per);
      this.parent.paginate[this.name].list = e;
    },
    goToPage(t) {
      const e = Math.ceil(this.list.length / this.per);
      if (t > e) {
        r(`You cannot go to page ${t}. The last page is ${e}.`, this.parent);
        return;
      }
      this.currentPage = (t || 1) - 1;
    }
  },
  render(t) {
    return this.$slots.default instanceof Function ? o(this.tag, {}, this.$slots.default()) : t(this.tag, {}, this.$slots.default);
  }
}, y = "«", $ = "»", u = "…";
class O {
  constructor(e, s, i) {
    this.listOfPages = e, this.lastPage = e.length - 1, this.currentPage = s === this.lastPage ? this.lastPage - 1 : s, this.limit = i;
  }
  generate() {
    const e = this._buildFirstHalf();
    let s = this._buildSecondHalf();
    return [...e, ...s];
  }
  _buildFirstHalf() {
    const e = this._allPagesButLast().slice(
      this._currentChunkIndex(),
      this._currentChunkIndex() + this.limit
    );
    return this.currentPage >= this.limit && (e.unshift(u), e.unshift(0)), this.lastPage - this.limit > this._currentChunkIndex() && e.push(u), e;
  }
  _buildSecondHalf() {
    return [this.lastPage];
  }
  _currentChunkIndex() {
    return Math.floor(this.currentPage / this.limit) * this.limit;
  }
  _allPagesButLast() {
    return this.listOfPages.filter((e) => e !== this.lastPage);
  }
}
const f = {
  name: "refapp-paginate-links",
  props: {
    for: {
      type: String,
      required: !0
    },
    limit: {
      type: Number,
      default: 0
    },
    simple: {
      type: Object,
      default: null,
      validator(t) {
        return t.prev && t.next;
      }
    },
    stepLinks: {
      type: Object,
      default: () => ({
        prev: y,
        next: $
      }),
      validator(t) {
        return t.prev && t.next;
      }
    },
    showStepLinks: {
      type: Boolean
    },
    hideSinglePage: {
      type: Boolean
    },
    classes: {
      type: Object,
      default: null
    },
    async: {
      type: Boolean,
      default: !1
    },
    container: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      listOfPages: [],
      numberOfPages: 0,
      target: null
    };
  },
  computed: {
    parent() {
      return this.container ? this.container.el : this.$parent;
    },
    state() {
      return this.container ? this.container.state : this.$parent.paginate[this.for];
    },
    currentPage: {
      get() {
        if (this.state)
          return this.state.page;
      },
      set(t) {
        this.state.page = t;
      }
    }
  },
  mounted() {
    this.simple && this.limit && r(
      `<paginate-links for="${this.for}"> 'simple' and 'limit' props can't be used at the same time. In this case, 'simple' will take precedence, and 'limit' will be ignored.`,
      this.parent,
      "warn"
    ), this.simple && !this.simple.next && r(
      `<paginate-links for="${this.for}"> 'simple' prop doesn't contain 'next' value.`,
      this.parent
    ), this.simple && !this.simple.prev && r(
      `<paginate-links for="${this.for}"> 'simple' prop doesn't contain 'prev' value.`,
      this.parent
    ), this.stepLinks && !this.stepLinks.next && r(
      `<paginate-links for="${this.for}"> 'step-links' prop doesn't contain 'next' value.`,
      this.parent
    ), this.stepLinks && !this.stepLinks.prev && r(
      `<paginate-links for="${this.for}"> 'step-links' prop doesn't contain 'prev' value.`,
      this.parent
    ), c(() => {
      this.updateListOfPages();
    });
  },
  watch: {
    state: {
      handler() {
        this.updateListOfPages();
      },
      deep: !0
    },
    currentPage(t, e) {
      this.$emit("change", t + 1, e + 1);
    }
  },
  methods: {
    updateListOfPages() {
      if (this.target = _(this.parent, this.for), !this.target) {
        if (this.async) return;
        r(
          `<paginate-links for="${this.for}"> can't be used without its companion <paginate ref="${this.for}">`,
          this.parent
        ), r(
          'To fix that issue you may need to use :async="true" on <paginate-links> component to allow for asyncronous rendering',
          this.parent,
          "warn"
        );
        return;
      }
      this.numberOfPages = Math.ceil(this.target.list.length / this.target.per), this.listOfPages = w(this.numberOfPages);
    }
  },
  render() {
    if (!this.target && this.async) return null;
    let t = this.simple ? C(this) : this.limit > 1 ? x(this) : b(this);
    if (this.hideSinglePage && this.numberOfPages <= 1)
      return null;
    const e = o(
      "ul",
      {
        class: ["paginate-links", this.for]
      },
      t
    );
    return this.classes && c(() => {
      A(e.el, this.classes);
    }), e;
  }
};
function b(t) {
  return (t.showStepLinks ? [t.stepLinks.prev, ...t.listOfPages, t.stepLinks.next] : t.listOfPages).map((s) => {
    const i = {
      onClick: (l) => {
        l.preventDefault(), t.currentPage = P(
          s,
          t.limit,
          t.currentPage,
          t.listOfPages,
          t.stepLinks
        );
      }
    }, a = L(
      s,
      t.currentPage,
      t.listOfPages.length - 1,
      t.stepLinks
    ), n = s === t.stepLinks.next || s === t.stepLinks.prev ? s : s + 1;
    return o("li", { class: a }, [o("a", i, n)]);
  });
}
function x(t) {
  let e = new O(
    t.listOfPages,
    t.currentPage,
    t.limit,
    t.stepLinks
  ).generate();
  e = t.showStepLinks ? [t.stepLinks.prev, ...e, t.stepLinks.next] : e;
  const s = S(e);
  return e.map((i, a) => {
    const n = {
      onClick: (h) => {
        h.preventDefault(), t.currentPage = P(
          i,
          t.limit,
          t.currentPage,
          t.listOfPages,
          t.stepLinks,
          s[a]
        );
      }
    }, l = L(
      i,
      t.currentPage,
      t.listOfPages.length - 1,
      t.stepLinks
    ), p = i === parseInt(i, 10) ? i + 1 : i;
    return o("li", { class: l }, [o("a", n, p)]);
  });
}
function C(t) {
  const e = t.listOfPages.length - 1, s = {
    onClick: (h) => {
      h.preventDefault(), t.currentPage > 0 && (t.currentPage -= 1);
    }
  }, i = {
    onClick: (h) => {
      h.preventDefault(), t.currentPage < e && (t.currentPage += 1);
    }
  }, a = { class: ["next", t.currentPage >= e ? "disabled" : ""] }, n = { class: ["prev", t.currentPage <= 0 ? "disabled" : ""] }, l = o("li", n, [o("a", s, t.simple.prev)]), p = o("li", a, [o("a", i, t.simple.next)]);
  return [l, p];
}
function _(t, e) {
  return t.$refs[e];
}
function w(t) {
  return Array.apply(null, { length: t }).map((e, s) => s);
}
function L(t, e, s, { prev: i, next: a }) {
  let n = [];
  return t === i ? n.push("left-arrow") : t === a ? n.push("right-arrow") : t === u ? n.push("ellipses") : n.push("number"), t === e && n.push("active"), (i === t && e <= 0 || a === t && e >= s) && n.push("disabled"), n;
}
function P(t, e, s, i, { prev: a, next: n }, l = null) {
  let p = Math.floor(s / e);
  if (t === a)
    return s - 1 < 0 ? 0 : s - 1;
  if (t === n)
    return s + 1 > i.length - 1 ? i.length - 1 : s + 1;
  if (l && l === "right-ellipses")
    return (p + 1) * e;
  if (l && l === "left-ellipses") {
    const h = i.slice(p * e, p * e + e);
    return s === i.length - 1 && h.length === 1 && p--, (p - 1) * e + e - 1;
  }
  return t;
}
function S(t) {
  return t.map((e, s) => e === u && t[s - 1] === 0 ? "left-ellipses" : e === u && t[s - 1] !== 0 ? "right-ellipses" : e);
}
function A(t, e) {
  Object.keys(e).forEach((s) => {
    if (s === "ul") {
      const i = e.ul;
      Array.isArray(i) ? i.forEach((a) => t.classList.add(a)) : t.classList.add(i);
    }
    t.querySelectorAll(s).forEach((i) => {
      const a = e[s];
      Array.isArray(a) ? a.forEach((n) => i.classList.add(n)) : i.classList.add(a);
    });
  });
}
const I = (t = []) => t.reduce((e, s) => (e[s] = {
  list: [],
  page: 0
}, e), {}), M = {
  install(t) {
    t.mixin({
      created() {
        this.paginate !== "undefined" && this.paginate instanceof Array && (this.paginate = I(this.paginate));
      },
      methods: {
        paginated(e) {
          if (!this.paginate || !this.paginate[e]) {
            r(`'${e}' is not registered in 'paginate' array.`, this);
            return;
          }
          return this.paginate[e].list;
        }
      }
    }), t.component(g.name, g), t.component(f.name, f);
  }
};
export {
  M as default
};
//# sourceMappingURL=refapp-vue-paginate.mjs.map
